module.exports = __webpack_public_path__ + "img/avatar_100x100.d834b5a5.jpg";